// import { orderingInitialState } from '@reducers/ordering/orderingInitialState';
import { OrderingInitialState, SetDataUpdateOrderAction } from '@reducers/ordering/types';

export const setDataUpdateOrder = (
  state: OrderingInitialState,
  action: SetDataUpdateOrderAction
): OrderingInitialState => ({
  ...state,
  ...(action.payload as OrderingInitialState),
});
